<template>
  <div class="dropdown-menu" id="dropdown-activity-status">
    <template v-if="loadingActivity">
      <p class="notice-activity">Sit tight! We're updating your status.</p>
    </template>
    <template v-else>
      <template v-if="currentStatus !== 'busy'">
        <a
          v-for="activity in availableActivities(currentStatus)"
          href="#"
          :key="activity.status"
          :class="`dropdown-item activity-item ${activity.class}`"
          :data-activity="activity.status"
          @click="changeUserStatus(activity.status)"
        >
          <span class="icon"></span>
          <span>{{ activity.label }}</span>
        </a>
      </template>
      <template v-else>
        <p class="notice-activity">
          Please finish your <b>{{ currentStatusLabel }}</b> to change the status
        </p>
      </template>
    </template>
  </div>
</template>

<script>
import axios from "axios"
import { mapState, mapGetters, mapMutations } from "vuex"
import { Activity } from "../../services/api/user-activity";

export default {
  name: "UserActivityOptions",
  props: {
    currentStatus: {
      type: String,
      default: "offline"
    },
    currentStatusLabel: {
      type: String,
      default: "Inactive"
    }
  },
  computed: {
    ...mapState("activity", ["activities", "loadingActivity"]),
    ...mapGetters("activity", ["availableActivities"])
  },
  methods: {
    ...mapMutations("activity", ["SET_LOADING_ACTIVITY"]),

    async changeUserStatus(status) {
      this.SET_LOADING_ACTIVITY(true);

      try {
        await Activity.changeStatus(status);
      } catch (error) {
        console.error('Error changing status:', error);
      } finally {
        // Handle potential race condition
        setTimeout(() => {
          this.SET_LOADING_ACTIVITY(false);
        }, 1000);
      }
    }
  }
}
</script>
